import type { CSSProperties } from "react";
import { parseLinks, type TextSegment } from "@/lib/linkify";
import { cn } from "@/lib/utils";

type LinkifiedTextProps = {
  text: string;
  className?: string;
  style?: CSSProperties;
};

/**
 * Fritext med klickbara länkar — DH Marknads `[[ … ]]` och vanliga
 * webbadresser. Radbrytningar behålls som i {@link RichTextParagraph}.
 */
export function LinkifiedText({ text, className, style }: LinkifiedTextProps) {
  return (
    <p className={cn("whitespace-pre-wrap break-words", className)} style={style}>
      <LinkifiedSegments segments={parseLinks(text)} />
    </p>
  );
}

export function LinkifiedSegments({ segments }: { segments: TextSegment[] }) {
  return segments.map((segment, index) =>
    segment.kind === "link" ? (
      <TextLink key={index} href={segment.href} label={segment.label} />
    ) : (
      <span key={index}>{segment.text}</span>
    )
  );
}

export function TextLink({ href, label }: { href: string; label: string }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer nofollow"
      className="break-all font-medium text-brand underline underline-offset-2 hover:text-brand-700"
    >
      {label}
    </a>
  );
}
